// 设备型号 + 功能项查询
// 反编译 + 开放平台文档：base /device/device_model_list GET
// 参数: device_auto_id (数字 device_id) + channel_id
// 返回 modelinfo.device_function 是逗号分隔的功能 ID 字符串
//   1=实时视频 2=历史视频 3=录像下载 4=云台PTZ 5=音频输入(拾音)
//   6=音频输出(对讲) 7=命令截图 8=远程升级 9=支持变焦 10=预设位置
//   16/18/24 = 内部扩展能力
import { callInternal } from './internal.js';

export const FN = {
	LIVE: 1,
	HISTORY: 2,
	DOWNLOAD: 3,
	PTZ: 4,
	AUDIO_IN: 5,        // 拾音（设备 → 用户）
	AUDIO_OUT: 6,       // 喊话/对讲（用户 → 设备）
	SCREENSHOT: 7,
	UPGRADE: 8,
	ZOOM: 9,
	PRESET: 10,
} as const;

interface ModelInfoResponse {
	modelinfo?: {
		device_function?: string;     // "1,2,3,4,5,6,7,8,10,16,24"
		model_name?: string;
		channel_num?: number;
		[k: string]: unknown;
	};
	[k: string]: unknown;
}

export interface DeviceCapabilities {
	functions: Set<number>;
	modelName: string;
	channelNum: number;
	supports: (id: number) => boolean;
}

const cache = new Map<string, DeviceCapabilities>();

export async function fetchDeviceCapabilities(
	deviceAutoId: string | number,
	channelId: string | number = 1,
): Promise<DeviceCapabilities | null> {
	const key = `${deviceAutoId}-${channelId}`;
	if (cache.has(key)) return cache.get(key)!;

	const res = await callInternal<ModelInfoResponse>({
		short_name: 'base',
		action: '/device/device_model_list',
		method: 'GET',
		query: { device_auto_id: String(deviceAutoId), channel_id: String(channelId) },
		av: '1',
	});

	if (res.code !== 0 || !res.data?.modelinfo) return null;

	const fnStr = res.data.modelinfo.device_function ?? '';
	const functions = new Set<number>(
		fnStr.split(',').map((s) => parseInt(s.trim(), 10)).filter((n) => !Number.isNaN(n)),
	);

	const cap: DeviceCapabilities = {
		functions,
		modelName: res.data.modelinfo.model_name ?? '',
		channelNum: res.data.modelinfo.channel_num ?? 1,
		supports: (id) => functions.has(id),
	};
	cache.set(key, cap);
	return cap;
}
